/**
 * Workspace domain types.
 *
 * A workspace is a self-contained context — its own conversations, knowledge
 * collections, notes, prompts, projects, tasks, and AI defaults. Every
 * workspace-scoped entity carries a `workspaceId` foreign key; switching the
 * active workspace (`stores/workspaceStore.ts`) re-filters all of them.
 * See `WORKSPACE_SYSTEM.md`.
 */
import type { ChatParams } from "./chat";

export interface Workspace {
  readonly id: string;
  name: string;
  /** Lucide icon name (e.g. "Layers", "Briefcase") shown in the switcher. */
  icon: string;
  color: string | null;
  /** Model id new conversations in this workspace default to; falls back to
   * `settingsStore.defaultModelId` when unset. */
  defaultModel: string | null;
  aiParams: Partial<ChatParams>;
  /** The workspace every fresh install starts with; never deletable. */
  readonly isDefault: boolean;
  readonly createdAt: number;
  updatedAt: number;
}

export const DEFAULT_WORKSPACE_ID = "workspace_default";
